// removed by extract-text-webpack-plugin
module.exports = {"hidden":"mZHMf","visuallyhidden":"BEJpi","hide-text":"_2ItUs","center":"_1zyI2","noprint":"_2vxOV","root":"_19uJo"};


/*****************
 ** WEBPACK FOOTER
 ** ./themes/ui-svg/styles/default.scss
 ** module id = 1020
 ** module chunks = 2
 **/